module.exports = __webpack_public_path__ + "img/边框.5f1b0c8c.png";